import React, { Component } from "react";

import { Wrapper, Row } from "app/NativeComponents/common";

import Tab from "./Tab";

class BoxTabs extends Component {
  render() {
    if (this.props.include_tabs) {
      return (
        <Wrapper style={{ padding: 10, paddingLeft: 15, paddingRight: 15 }}>
          <Row>
            <Tab
              title={"Message"}
              is_active={this.props.tab == "message"}
              onPress={() => this.props.toggleTab("message")}
              colors={this.props.colors}
            />
            <Tab
              title={"Note"}
              is_active={this.props.tab == "note"}
              onPress={() => this.props.toggleTab("note")}
              colors={this.props.colors}
            />
          </Row>
        </Wrapper>
      );
    } else {
      switch (this.props.tab) {
        case "note":
        default:
          return (
            <Row style={{ padding: 10, paddingLeft: 15, paddingRight: 15 }}>
              <Tab
                title={"Note"}
                is_active={true}
                colors={this.props.colors}
                disabled={true}
              />
            </Row>
          );
        case "message":
          return (
            <Row style={{ padding: 10, paddingLeft: 15, paddingRight: 15 }}>
              <Tab
                title={"Message"}
                is_active={true}
                colors={this.props.colors}
                disabled={true}
              />
            </Row>
          );
      }
    }
  }
}

export default BoxTabs;
